"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelEventLabel = void 0;
var CancelEventLabel;
(function (CancelEventLabel) {
    CancelEventLabel["CHANGE_PASSWORD"] = "Change password";
    CancelEventLabel["DELETE_ACCOUNT"] = "Delete account";
})(CancelEventLabel || (exports.CancelEventLabel = CancelEventLabel = {}));
//# sourceMappingURL=CancelEventLabel.js.map